export const formatAddress = (address, padding = 6) => {
  if (address && address.length > 0) {
    return `${address.substr(0, padding)}…${address.substr(-3)}`;
  } else {
    return address;
  }
};


export const preventNonNumericalDotInput = (evt) => {
  if (
    ((evt.which !== 8 && evt.which !== 0 && evt.which < 48) ||
      evt.which > 57) &&
    evt.which !== 46
  ) {
    evt.preventDefault();
  }
}